import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/fans/")({
  beforeLoad: () => {
    throw redirect({ to: "/", replace: true });
  },
});
